export default __webpack_public_path__ + "static/media/034-door.13727ade.png";